<template>
  <!-- 表格头部 -->
  <thead class="table-thead">
    <tr>
      <th-ex v-if="$parent.$props.showIndex" class="head-index-th">序号</th-ex>
      <slot></slot>
    </tr>
  </thead>
</template>

<script>
export default {
  name: "TheadEx",
};
</script>

<style lang="stylus" scoped>
.head-index-th
    width 35px!important
    text-align center
</style>
